import { QuestionType } from "../types/enums";
import { Question } from "../types/Question";

export function getPrompt(format: QuestionType) {
    
    switch (format) {
        case QuestionType.IS_FACTOR:
            return "Which of these is a factor of:"

        case QuestionType.IS_NOT_FACTOR:
            return "Which of these is NOT a factor of:"

        case QuestionType.IS_MULTIPLE:
            return "Which of these is a multiple of:"

        case QuestionType.IS_NOT_MULTIPLE:
            return "Which of these is NOT a multiple of:"

        case QuestionType.REGULAR:
            return "Solve the equation"
    }
}

export  function getQuestionType(questions: Question[]) {
    if (questions.length < 0) {
        return undefined;
    }

    return questions[0].type;
}